<ng-container
    *ngIf="{
        isOpenMenu: isOpenMenu$ | async,
        lastSectionIndex: lastSectionIndex$ | async,
        activeCategories: activeCategories$ | async,
        cartItems: cartItem$ | async,
        isLogged: isAuthenticated$ | async,
        isOpenForSale: isOpenForSale$ | async,
        debugShowCategoryId: showCategoryId$ | async,
        isRtl: isRtl$ | async,
        isMobile: isMobile$ | async,
        scrollToCategory: scrollToCategory$ | async,
        homePagesUrl: homePagesUrl$ | async,
        username: username$ | async
    } as headerData"
>
    <div class="mn-overlay" [class.is-active]="headerData.isOpenMenu" (click)="closeMenu()"></div>
    <nav class="mn-mainmenu min-overflow" #mainMenu [class.is-active]="headerData.isOpenMenu" [class.is-rtl]="headerData.isRtl">
        <div class="mn-mainmenu-header">
            <app-header-topbar-sm-2024
                class="pt-2"
                [icon]="'close'"
                [cartItems]="headerData.cartItems"
                [isOpenForSale]="headerData.isOpenForSale"
                [isLogged]="headerData.isLogged"
            ></app-header-topbar-sm-2024>
        </div>
        <div class="mn-mainmenu-body">
            <a class="mn-superlogo" [href]="homeSeoUrl$ | async" (click)="goToHome($event)" [attr.aria-label]="titleLogoDom">
                <md-icon name="md-logo"></md-icon>
            </a>

            @defer (on immediate) {
                <div class="tabs">
                    <ul class="mn-list-item">
                        <ng-container *ngFor="let category of categories; let i = index">
                            <li class="mn-list-item-section" (click)="openSection(i)" [class.is-active]="i === headerData.lastSectionIndex">
                                <h2 class="text-l">
                                    <a
                                        class="mn-list-item-link-section"
                                        [href]="headerData.homePagesUrl ? headerData.homePagesUrl[i] : category.locationPath"
                                        (click)="nothing($event)"
                                    >
                                        {{ category.name | translate }}
                                    </a>
                                </h2>
                            </li>
                            <li class="mn-inner min-scrollcustom-hover" [class.show-subcategories-section]="i === headerData.lastSectionIndex">
                                <ng-container *ngFor="let mainCategory of categories; let indexCategory = index">
                                    <ng-container *ngIf="indexCategory === i">
                                        <ul
                                            class="mn-list list-check text-l"
                                            *ngFor="let category of mainCategory.subcategories; let index = index"
                                            [ngClass]="category.isDivider ? category.className : ''"
                                        >
                                            <li
                                                *ngIf="!category.isDivider"
                                                header-menu-category
                                                [indexItem]="index"
                                                [category]="category"
                                                [activeCategories]="headerData.activeCategories"
                                                [debugShowCategoryId]="headerData.debugShowCategoryId"
                                                [sectionIndex]="indexCategory"
                                                [isRtl]="headerData.isRtl"
                                                [sectionName]="mainCategory.name | translate"
                                                (sendOpenCategory)="openCategory($event)"
                                                (sendOpenSubCategory)="openSubCategory($event)"
                                            ></li>
                                        </ul>
                                    </ng-container>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            }
            <hr class="header-divider-desktop" />
        </div>
        <div class="mn-mainmenu-footer">
            <div class="mn-search-zone">
                <div
                    class="list-clear text-right is-flex content-center align-items-center"
                    style="height: 56px; z-index: 10; background: rgba(255, 255, 255, 0.97); position: relative"
                >
                    <button
                        class="btn ttu"
                        (click)="goUserAccount(headerData.isLogged)"
                        *ngIf="headerData.isOpenForSale"
                        style="padding: 0; height: 100%"
                    >
                        @if (!headerData.isLogged) {
                            {{ 'header_login' | translate }}
                        } @else {
                            {{ headerData.username || ('header_my_account' | translate) }}
                        }
                    </button>
                </div>
            </div>
        </div>
    </nav>
</ng-container>
<ng-template #headerSearch>
    <header-search></header-search>
</ng-template>
